import { Tooltip } from "@mui/material"
import styles from '@/styles/components/SharedDetailStatus.module.scss'

export default function SharedDetailStatus() {
  return (
    <Tooltip
      sx={{ color: "#202B7E" }}
      title="This is a shared setting used across the business. You can deactivate it but may not be able to delete it."
    >
      <div className={'entry-action-container'} style={{ display: "flex", columnGap: 8, alignItems: "center" }}>
        <img height="20" src="/icons/shared-setting.svg" alt="" />
        <p className={styles['label']} style={{ fontSize: 14, fontWeight: 600, color: "#757575" }}>
          Shared
        </p>
      </div>
    </Tooltip>
  )
}
